import React, { useState, useEffect, useCallback } from 'react';
const galleryImages = [{
  src: "https://summary-monarch.10web.cloud/wp-content/uploads/2026/05/image23.jpeg?v=zacfd47581",
  srcset: "https://summary-monarch.10web.cloud/wp-content/uploads/2026/05/image23.jpeg?v=q8sux6i5x3j-wvc-srcset",
  sizes: "https://summary-monarch.10web.cloud/wp-content/uploads/2026/05/image23.jpeg?v=p88fkq8gz2m-wvc-sizes",
  alt: "Արբանյակային պատկեր 1"
}, {
  src: "https://summary-monarch.10web.cloud/wp-content/uploads/2026/05/image27.jpeg?v=gv0sb3f49l",
  srcset: "https://summary-monarch.10web.cloud/wp-content/uploads/2026/05/image20.png?v=khhlqxkr1uh-wvc-srcset",
  sizes: "https://summary-monarch.10web.cloud/wp-content/uploads/2026/05/image20.png?v=ag10rbsdmwt-wvc-sizes",
  alt: "Լուսնի մակերևույթ"
}, {
  src: "https://summary-monarch.10web.cloud/wp-content/uploads/2026/05/image20.png?v=e8nbko09tmc",
  srcset: "https://summary-monarch.10web.cloud/wp-content/uploads/2026/05/image20.png?v=7qmbd7pjn1u-wvc-srcset",
  sizes: "https://summary-monarch.10web.cloud/wp-content/uploads/2026/05/image20.png?v=hdamw40pdxr-wvc-sizes",
  alt: "Արբանյակային պատկեր 2"
}, {
  src: "https://summary-monarch.10web.cloud/wp-content/uploads/2026/05/image25.jpeg?v=8kfilab84sj",
  srcset: "https://summary-monarch.10web.cloud/wp-content/uploads/2026/05/image25.jpeg?v=nt23n0iflop-wvc-srcset",
  sizes: "https://summary-monarch.10web.cloud/wp-content/uploads/2026/05/image25.jpeg?v=z3cyl9k3ovo-wvc-sizes",
  alt: "Արբանյակային պատկեր 3"
}, {
  src: "https://summary-monarch.10web.cloud/wp-content/uploads/2026/05/image22.jpeg?v=f637oislk1m",
  srcset: "https://summary-monarch.10web.cloud/wp-content/uploads/2026/05/image22.jpeg?v=218ojwpr42j-wvc-srcset",
  sizes: "https://summary-monarch.10web.cloud/wp-content/uploads/2026/05/image22.jpeg?v=918wfo3p2z-wvc-sizes",
  alt: "Արբանյակային պատկեր 4"
}, {
  src: "https://summary-monarch.10web.cloud/wp-content/uploads/2026/05/image24.jpeg?v=1kkvtqda6ms",
  srcset: "https://summary-monarch.10web.cloud/wp-content/uploads/2026/05/image22.jpeg?v=sva458xgho?v=n0eumwy4ip-wvc-srcset",
  sizes: "https://summary-monarch.10web.cloud/wp-content/uploads/2026/05/image22.jpeg?v=6cpjmwrqji?v=zeangds00us-wvc-sizes",
  alt: "Արբանյակային պատկեր 5"
}];
export default function Gallery() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false); // Նոր state՝ մեծացված նկարի համար
  const totalSlides = galleryImages.length;

  // Էկրանի չափի ստուգում՝ ռեսպոնսիվ դիզայնի համար
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  const nextSlide = useCallback(() => {
    setCurrentIndex(prev => (prev + 1) % totalSlides);
  }, [totalSlides]);
  const prevSlide = useCallback(() => {
    setCurrentIndex(prev => (prev - 1 + totalSlides) % totalSlides);
  }, [totalSlides]);
  const goToSlide = index => {
    setCurrentIndex(index);
  };

  // Սլայդերի ոճերի և դիրքավորման հաշվարկ (Coverflow էֆեկտ)
  const getSlideStyles = index => {
    let offset = index - currentIndex;

    // Անվերջ պտտման տրամաբանություն
    if (offset < -Math.floor(totalSlides / 2)) offset += totalSlides;
    if (offset > Math.floor(totalSlides / 2)) offset -= totalSlides;
    const xOffset = isMobile ? 80 : 65; // Կողային նկարների հեռավորությունը

    if (offset === 0) {
      // Կենտրոնական ակտիվ նկար
      return {
        transform: 'translateX(0) scale(1)',
        zIndex: 10,
        opacity: 1,
        filter: 'brightness(1)',
        pointerEvents: 'auto'
      };
    } else if (offset === -1) {
      // Ձախ նկար
      return {
        transform: `translateX(-${xOffset}%) scale(0.85)`,
        zIndex: 5,
        opacity: 0.7,
        filter: 'brightness(0.4)',
        pointerEvents: 'auto'
      };
    } else if (offset === 1) {
      // Աջ նկար
      return {
        transform: `translateX(${xOffset}%) scale(0.85)`,
        zIndex: 5,
        opacity: 0.7,
        filter: 'brightness(0.4)',
        pointerEvents: 'auto'
      };
    } else {
      // Թաքնված նկարներ
      const direction = offset < 0 ? -1 : 1;
      return {
        transform: `translateX(${direction * 150}%) scale(0.5)`,
        zIndex: 1,
        opacity: 0,
        filter: 'brightness(0)',
        pointerEvents: 'none'
      };
    }
  };
  return <section id="gallery" className="bg-zinc-950 py-16 md:py-24 overflow-hidden relative">
      <div className="container mx-auto px-4 md:px-6">
        
        {/* Վերնագիր */}
        <div className="mb-16 text-center">
          <h2 className="font-default text-3xl font-bold tracking-tight text-zinc-50 sm:text-4xl md:text-5xl">
            Արմսաթ1 Արբանյակի նկարներ
          </h2>
        </div>

        {/* Կարուսել */}
        <div className="relative w-full max-w-6xl h-[350px] md:h-[500px] mx-auto flex items-center justify-center" style={{
        perspective: '1000px'
      }}>
          
          {/* Նկարների ցուցադրում */}
          {galleryImages.map((image, index) => {
          const isCenter = index === currentIndex;
          return <img key={index} src={image.src} data-wvc-srcset={image.srcset} data-wvc-sizes={image.sizes} alt={image.alt} loading="lazy" onClick={() => {
            if (!isCenter) {
              goToSlide(index);
            } else {
              setIsFullscreen(true); // Բացել մեծացված տարբերակը
            }
          }} className={`absolute w-[75%] md:w-[60%] max-w-[700px] h-full object-cover rounded-2xl shadow-[0_15px_35px_rgba(0,0,0,0.6)] cursor-pointer will-change-transform ${isCenter ? 'hover:scale-[1.02] transition-transform' : ''}`} style={{
            ...getSlideStyles(index),
            transition: 'transform 0.5s cubic-bezier(0.25, 1, 0.5, 1), opacity 0.5s ease, filter 0.5s ease'
          }} />;
        })}

          {/* Ձախ սլաք */}
          <button onClick={prevSlide} aria-label="Նախորդ նկար" className="absolute left-2 md:left-5 top-1/2 -translate-y-1/2 z-20 w-12 h-12 rounded-full bg-zinc-800/60 border border-white/10 text-white flex items-center justify-center backdrop-blur-sm transition-all hover:bg-zinc-700/90 active:scale-95">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6">
              <path d="m15 18-6-6 6-6" />
            </svg>
          </button>
          
          {/* Աջ սլաք */}
          <button onClick={nextSlide} aria-label="Հաջորդ նկար" className="absolute right-2 md:right-5 top-1/2 -translate-y-1/2 z-20 w-12 h-12 rounded-full bg-zinc-800/60 border border-white/10 text-white flex items-center justify-center backdrop-blur-sm transition-all hover:bg-zinc-700/90 active:scale-95">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6">
              <path d="m9 18 6-6-6-6" />
            </svg>
          </button>

          {/* Էջանշաններ (Pagination) */}
          <div className="absolute -bottom-10 left-1/2 -translate-x-1/2 flex items-center gap-2 z-20">
            {galleryImages.map((_, index) => {
            const isActive = index === currentIndex;
            return <button key={index} onClick={() => goToSlide(index)} aria-label={`Գնալ սլայդ ${index + 1}`} className={`h-2.5 rounded-full transition-all duration-300 ${isActive ? 'w-8 bg-[#00d2ff]' : 'w-2.5 bg-zinc-600 hover:bg-zinc-500'}`} />;
          })}
          </div>

        </div>
      </div>

      {/* Մեծացված նկարի Overlay (Lightbox) */}
      {isFullscreen && <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/95 backdrop-blur-md p-4 animate-in fade-in duration-300">
          
          {/* Փակելու X կոճակ */}
          <button onClick={() => setIsFullscreen(false)} className="absolute top-6 right-6 md:top-10 md:right-10 z-[110] w-12 h-12 rounded-full bg-zinc-800/80 border border-white/10 text-white flex items-center justify-center transition-all hover:bg-red-500/90 hover:scale-105 active:scale-95" aria-label="Փակել նկարը">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>

          {/* Նկար */}
          <img src={galleryImages[currentIndex].src} alt={galleryImages[currentIndex].alt} className="max-w-[95vw] max-h-[90vh] object-contain rounded-lg shadow-2xl scale-100" />
        </div>}
    </section>;
}